// src/hooks/useChatHistory.js
import { useState, useCallback } from 'react';
import {
  getClienteConversas,
  getConversaByAtendimento,
} from '../services/chatService';

export const useChatHistory = (clienteId, open) => {
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [listaConversas, setListaConversas] = useState([]);
  const [conversaAberta, setConversaAberta] = useState(null);
  const [erroHistorico, setErroHistorico] = useState(null);

  // Handler que CARREGA a conversa aberta
  const abrirConversaEspecifica = useCallback(
    async (conv) => {
      if (!conv?.atendimentoId || !clienteId) {
        setConversaAberta(conv || null);
        return;
      }
      try {
        const data = await getConversaByAtendimento(clienteId, conv.atendimentoId);
        setConversaAberta(data || conv);
      } catch {
        setConversaAberta(conv);
      }
    },
    [clienteId]
  );

  // Handler que CARREGA a lista de conversas do cliente
  const fetchHistorico = useCallback(async () => {
    if (!open || !clienteId) return;
    setLoadingHistorico(true);
    setErroHistorico(null);
    setListaConversas([]);
    setConversaAberta(null);
    try {
      const data = await getClienteConversas(clienteId);
      const arr = Array.isArray(data) ? data : Object.values(data || {});
      const validas = arr.filter((c) => c.dataFim);
      const ordenado = validas.sort(
        (a, b) => new Date(b.dataFim) - new Date(a.dataFim)
      );
      setListaConversas(ordenado);
      if (ordenado[0]) await abrirConversaEspecifica(ordenado[0]);
    } catch (e) {
      setErroHistorico(e.message);
      setListaConversas([]);
      setConversaAberta(null);
    } finally {
      setLoadingHistorico(false);
    }
  }, [clienteId, open, abrirConversaEspecifica]);

  return {
    loadingHistorico,
    listaConversas,
    conversaAberta,
    erroHistorico,
    fetchHistorico,
    abrirConversaEspecifica,
    setConversaAberta, // Se quiser permitir reset manual
  };
};
